const RETRY_INTERVAL = 5000;
const RETRY_TIMES = 2;

class FetchHandler {
  constructor() {
    this.retryTimeout = null;
  }

  init(requestUrl, requestOptions,
    { retryTimes = RETRY_TIMES, retryTimeout = RETRY_INTERVAL, reportError = true } = {},
  ) {
    return new Promise((resolve, reject) => {
      window.fetch(requestUrl, requestOptions).then((response) => {
        if (response.status !== 200 && this.retryTimes > 0) {
          if ([403, 404].includes(response.status)) {
            if (this.retryTimeout) {
              clearTimeout(this.retryTimeout);
              this.retryTimeout = null;
            }
            resolve(response.json());
            return;
          }
          this.retryTimeout = setTimeout(() =>
            this.init(requestUrl, requestOptions, retryTimes - 1, retryTimeout),
          retryTimeout);
        } else {
          if (this.retryTimeout) {
            clearTimeout(this.retryTimeout);
            this.retryTimeout = null;
          }
          resolve(response.json());
        }
      }).catch((error) => {
        if (reportError) {
          console.log(error);
        }
        reject(error);
      });
    });
  }
}

export default new FetchHandler();
